import request from '@/utils/request'

// 查询角色列表
export function listRole(params) {
  return request({
    url: '/system/role/listTenantRole',
    params,
    headers: {
      isSaas: true
    }
  })
}

// saas平台查询角色详细
export function getRole(roleId) {
  return request({
    url: `/system/role/detailTenantRole?roleId=${roleId}`,
    method: 'get',
    headers: {
      isSaas: true
    }
  })
}


// 私有化部署查询角色详细
export function getRolePrivate(params) {
  return request({
    url: `/system/role/detailTenantRole-private/${params.privateName}?roleId=${params.roleId}`,
    method: 'get',
    headers: {
      isSaas: true
    }
  })
}

// 新增角色
export function addRole(data) {
  return request({
    url: '/system/role/addTenantRole',
    method: 'post',
    data,
    headers: {
      isSaas: false
    }
  })
}

// 修改角色
export function updateRole(data) {
  return request({
    url: '/system/role/editTenantRole',
    method: 'put',
    data,
    headers: {
      isSaas: false
    }
  })
}


// 新增角色-私有化
export function addRolePrivate(data) {
  return request({
    url: '/system/role/addTenantRole-private',
    method: 'post',
    data,
    headers: {
      isSaas: true
    }
  })
}

// 修改角色-私有化
export function updateRolePrivate(data) {
  return request({
    url: '/system/role/editTenantRole-private',
    method: 'put',
    data,
    headers: {
      isSaas: true
    }
  })
}



// 角色数据权限
export function dataScope(data) {
  return request({
    url: '/system/role/dataScope',
    method: 'post',
    data,
    headers: {
      isSaas: true
    }
  })
}

// 角色状态修改
export function changeRoleStatus(roleId, status) {
  const url = status == 1 ? '/system/role/disableTenantRole' : '/system/role/enableTenantRole'
  return request({
    url: `${url}?roleId=${roleId}`,
    method: 'put',
    headers: {
      isSaas: true
    }
  })
}

// 删除角色
export function delRole(roleId) {
  return request({
    url: `/system/role/deleteTenantRole?roleId=${roleId}`,
    method: 'delete',
    headers: {
      isSaas: false
    }
  })
}

// 查询角色已授权用户列表
export function allocatedUserList(query) {
  return request({
    url: '/system/role/authUser/allocatedList',
    method: 'get',
    params: query,
    headers: {
      isSaas: true
    }
  })
}

// 查询角色未授权用户列表
export function unallocatedUserList(query) {
  return request({
    url: '/system/role/authUser/unallocatedList',
    method: 'get',
    params: query,
    headers: {
      isSaas: true
    }
  })
}

// 取消用户授权角色
export function authUserCancel(data) {
  return request({
    url: '/system/role/authUser/cancel',
    method: 'post',
    data,
    headers: {
      isSaas: true
    }
  })
}

// 批量取消用户授权角色
export function authUserCancelAll(data) {
  return request({
    url: '/system/role/authUser/cancelAll',
    method: 'post',
    params: data,
    headers: {
      isSaas: true
    }
  })
}

// 授权用户选择
export function authUserSelectAll(data) {
  return request({
    url: '/system/role/authUser/selectAll',
    method: 'post',
    params: data,
    headers: {
      isSaas: true
    }
  })
}
